module.exports = __webpack_public_path__ + "static/img/eureka_icon_7.a34782a2.png";